import React from "react";
import Icon from "../../../v2/components/icons/Icon";

export default ({ name }) => (
  <Icon name={name} height={28} width={50} />
)